function StorageUnavailableScreen() {
  return (
    <div role="alert" aria-live="assertive">
      <h1>Storage Unavailable</h1>
      <p>
        This app requires local storage to function. This may be because:
      </p>
      <ul>
        <li>You are browsing in private/incognito mode</li>
        <li>Your device storage is full</li>
        <li>Your browser has storage disabled</li>
      </ul>
      <p>Please try again in a standard browser window.</p>
    </div>
  )
}

export default StorageUnavailableScreen